import { render, staticRenderFns } from "./AddNews.vue?vue&type=template&id=7ebe5fb0&scoped=true"
import script from "./AddNews.vue?vue&type=script&lang=js"
export * from "./AddNews.vue?vue&type=script&lang=js"
import style0 from "./AddNews.vue?vue&type=style&index=0&id=7ebe5fb0&prod&lang=scss&scoped=true"
import style1 from "./AddNews.vue?vue&type=style&index=1&id=7ebe5fb0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ebe5fb0",
  null
  
)

export default component.exports